// Отображаемый ref задачи. У backend нет номера — короткий id рендерим как есть,
// длинный (uuid) усекаем. Всегда mono-caps на стороне компонента.
export function taskRef(id: string): string {
  const short = id.length <= 8 ? id : id.slice(0, 6)
  return `#${short.toUpperCase()}`
}
